import { getDateNum } from 'utils/querySimulation';

const planetNames = {
	mushroomKingdom: 'Regno dei Funghi',
	honeyhiveGalaxy: 'Galassia Dolceape',
	fossilFalls: 'Rapide Fossili',
	cometObservatory: 'Osservatorio Cometa',
	tostarenaTown: 'Tostalandia',
	dripDropGalaxy: 'Galassia Drip Drop',
	spaceJunkGalaxy: 'Polvere Di Stelle'
};

export default {
	$title: 'Varco<br/>Celestiale',
	$mushroomKingdom: planetNames.mushroomKingdom,
	$honeyhiveGalaxy: planetNames.honeyhiveGalaxy,
	$fossilFalls: planetNames.fossilFalls,
	$cometObservatory: planetNames.cometObservatory,
	$tostarenaTown: planetNames.tostarenaTown,
	$dripDropGalaxy: planetNames.dripDropGalaxy,
	$spaceJunkGalaxy: planetNames.spaceJunkGalaxy,
	$intro: {
		clickStar: 'Clicca la stella per entrare',
		toEnter: 'per entrare',
	},
	$boardingTimes: {
		title: 'Orari di imbarco',
		subtitle: 'Partenze attualmente in corso dal Varco Celestiale',
		boardingNow: 'In partenza',
		noFlightZone: 'Voli cancellati',
		delayed: 'In ritardo',
		altText: 'La pagina "Orari di Imbarco" del Varco Celestiale mostra le destinazioni di viaggio disponibili e future.',
	},
	$travelerNotices: {
		title: 'Avvisi ai Viaggiatori',
		missingAlert: '**Avete visto questa principessa?** Rosalinda è stata avvistata l’ultima volta all’Osservatorio Cometa. Segnalate eventuali informazioni al personale del Varco Celestiale.',
		starfox: "Looking for a pilot? Fox McCloud was recently spotted on our flight deck. He'll take you anywhere you want to go, for the right price.",
		starfoxButton: 'Discover more', //TRAVELER NOTICE EASTER EGG UPDATE
		starfoxEasterEggHeading: 'Fox McCloud', //TRAVELER NOTICE EASTER EGG UPDATE
		ukikiWarning: '**Avviso di furto.** <br/> Si consiglia ai visitatori di custodire con attenzione i propri effetti personali e di prestare attenzione all’ambiente circostante.',
		altText:
			'Avvisi ufficiali e comunicazioni per i visitatori del Varco Celestiale. Si prega di consultare tutti gli avvisi prima di proseguire il viaggio.',
	},
	$lostAndFound: {
		title: 'Oggetti Smarriti',
		subtitle: 'Gli oggetti recuperati dalla Sicurezza del Varco Celestiale vengono registrati qui per consultazione e ritiro.',
		items: {
			pineappleLuggage: { name: 'Trolley Fantasia Ananas', description: 'Valigia rigida con fantasia tropicale vivace.' },
			hardShellSuitcase: { name: 'Valigia Rigida', description: 'Contiene un martello con segni di artigli di Tantatalpa sul manico.' },
			iglooBackpack: { name: 'Zaino Igloo', description: 'Utilizzato per evitare che le scorte si scongelino durante il trasporto.' },
			superMushroom: { name: 'Super Fungo', description: 'Le dimensioni possono variare.' },
			greenTurtleShell: { name: 'Guscio Verde', description: 'Recuperato senza Koopa. Proprietario forse vicino e imbarazzato.' },
			toadsNovel: { name: 'Romanzo Incompiuto', description: 'Manoscritto parzialmente completato, trovato in un’area di sosta.' },
		},
		altText: 'La pagina Oggetti Smarriti, cataloga gli oggetti non reclamati recuperati all’interno del Varco Celestiale.',
	},
	$stayConnected: {
		title: 'Resta Connesso',
		subtitle: '**L’universo è vasto, pieno di galassie.** Resta aggiornato con le comunicazioni di R.O.B.',
		// description: 'Invia un SMS al 929-556-2746 per ricevere aggiornamenti dal Varco Celestiale durante la tua visita.',
		socials: [
			{ id: 'insta', name: 'Instagram', link: 'https://www.instagram.com/universalpicturesit/' },
			{ id: 'x', name: 'X', link: 'https://x.com/UniversalPicsIt' },
			{ id: 'tiktok', name: 'TikTok', link: 'https://www.tiktok.com/@universalpicturesit' },
		],
		altText: 'La pagina Resta Connesso, invita i visitatori a ricevere aggiornamenti e notifiche ufficiali dal Varco Celestiale.',
	},
	$passport: {
		title: 'Boarding Pass',
	},
	$showtimes: {
		title: 'Non perderlo al cinema',
	},
	$planetOverlays: {
		mushroomKingdom: {
			title: planetNames.mushroomKingdom,
			description: 'Una regione molto frequentata, nota per i suoi paesaggi, l’architettura distintiva e le comunità interconnesse.',
			conditions: 'Serene e mite. Venti leggeri e alta visibilità nella maggior parte delle aree.',
			seasonalOutlook: 'Condizioni stabili previste nei vari cicli Attività in aumento durante le ore diurne.',
			notice: 'A causa di circostanze impreviste, le visite al castello non saranno disponibili fino a nuovo avviso.',
		},
		honeyhiveGalaxy: {
			title: planetNames.honeyhiveGalaxy,
			description:
				'Un ambiente vibrante e sopraelevato, costruito tra fiori imponenti e strutture naturali. La Galassia Dolceape è nota per il suo terreno stratificato e l’ecosistema rigoglioso.',
			conditions: 'Clima caldo e luminoso con luce solare costante. Alti livelli di polline in diverse aree.',
			seasonalOutlook: 'Le condizioni restano sempre favorevoli. Picchi di attività durante la fioritura.',
			notice: 'Non calpestare i fiori.',
		},
		fossilFalls: {
			title: planetNames.fossilFalls,
			description:
				'Un paesaggio impervio caratterizzato da alte scogliere, corsi d’acqua e resti di un passato antico. Le Rapide Fossili sono note per il terreno spettacolare e l’abbondante attività naturale.',
			conditions: 'Clima caldo e limpido. Nebbia occasionale vicino a cascate e scogliere.',
			seasonalOutlook: 'Le condizioni restano quasi sempre stabili. Maggiore attività faunistica con massima luce.',
			notice: 'Evita di avvicinarti a creature di grandi dimensioni. Si sconsiglia di oltrepassare i percorsi segnalati.',
		},
		cometObservatory: {
			title: planetNames.cometObservatory,
			description:
				'Una struttura di osservazione sospesa nello spazio che permette il monitoraggio celeste a lungo raggio. Qui avviene lo studio, la navigazione e il controllo dei sistemi della galassia.',
			conditions: 'Condizioni orbitali stabili con bassa gravità. Interferenze atmosferiche minime.',
			seasonalOutlook: 'Alta visibilità prevista per il ciclo. Lievi variazioni possibili durante l’attività cometaria.',
			notice: 'Tripodobot avvistato di recente nell’area. Prestate attenzione.',
		},
		tostarenaTown: {
			title: planetNames.tostarenaTown,
			description:
				'Un insediamento desertico costruito tra antiche strutture in pietra e piazze scaldate dal sole. I viaggiatori vi transitano spesso attraversando le sabbie circostanti.',
			conditions: 'Caldo secco nelle ore diurne. Rapidi cali di temperatura dopo il tramonto.',
			seasonalOutlook: 'Previsti cieli sereni e forte esposizione al sole. Ombra limitata oltre i confini della città.',
			notice: 'Le festività locali potrebbero influire sui percorsi di transito standard.',
		},
		conditions: 'Condizioni attuali',
		seasonalOutlook: 'Tendenza stagionale',
		notice: 'Avviso',
		mobile: 'Mobile',
		desktop: 'Desktop',
		wallpapers: 'Sfondi',
	},
	$glyphs: {
		clown: 'Clown',
		peaches: 'Peaches',
		butterfly: 'Butterfly',
		mustache: 'Mustache',
		bones: 'Bones',
		bowser: 'Bowser',
		barrelRoll: 'Barrel Roll'
	},
	$showtimesLink: 'https://app.powster.com/universalstudios/the-super-mario-galaxy-movie-intl/it',
	$watchAtHomeLink: '',
	$upWorld: {
		easterEggHeading: 'Qualcosa si nasconde tra le stelle.',
	},
	$downWorld: {
		easterEggHeading: 'Super Bell',
	},
	$ROB: {
		homepage: {
			0: {
				question: 'Benvenuti nel Varco Celestiale. Io sono R.O.B. Come posso assisterti?',
				response: {
					0: 'Visualizza Destinazioni',
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò.',
				response: {
					0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id: 'fossilFalls', label: planetNames.fossilFalls },
					3: { id: 'cometObservatory', label: planetNames.cometObservatory },
					4: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					5: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					6: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		boardingTimes: {
			0: {
				question: 'Le informazioni sulle partenze sono aggiornate regolarmente.',
			},
			1: {
				question: 'Questa rotta non è ancora aperta.',
			},
		},
		travelerNotices: {
			0: {
				question: 'Si prega di consultare tutti gli avvisi attuali.',
				response: {
					0: 'Sono pronto a viaggiare.',
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò. ',
				response: {
					0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id: 'fossilFalls', label: planetNames.fossilFalls },
					3: { id: 'cometObservatory', label: planetNames.cometObservatory },
					4: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					5: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					6: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		stayConnected: {
			0: {
				question: 'Questo canale mi permette di raggiungerti ovunque tu sia.',
				response: {
					0: 'Ricevuto',
				},
			},
		},
		lostAndFound: {
			0: {
				question: 'Ho trovato molti di questi personalmente.',
				response: {
					0: 'Ricevuto',
				},
			},
		},
		watchAtHome: {
			0: {
				question: "That's the coolest guy I've ever seen.",
			},
		},
		mushroomKingdom: {
			0: {
				question: 'Questa è una destinazione ad alto afflusso. Prevedi folla.',
				response: {
					0: "Mostrami un'altra destinazione.",
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò.',
				response: {
					0: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					1: { id: 'fossilFalls', label: planetNames.fossilFalls },
					2: { id: 'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		honeyhiveGalaxy: {
			0: {
				question: 'Alti livelli di polline possono infastidire i viaggiatori sensibili.',
				response: {
					0: "'Mostrami un'altra destinazione.'",
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò.',
				response: {
					0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id: 'fossilFalls', label: planetNames.fossilFalls },
					2: { id: 'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		fossilFalls: {
			0: {
				question: 'Animali di grandi dimensioni avvistati nella regione. Mantieni le distanze.',
				response: {
					0: "Mostrami un'altra destinazione.",
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò.',
				response: {
					0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id: 'cometObservatory', label: planetNames.cometObservatory },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		cometObservatory: {
			0: {
				question: 'Per la visita è richiesta un’autorizzazione speciale.',
				response: {
					0: "Mostrami un'altra destinazione.",
				},
			},
			1: {
				question: 'Certo. Scegli la destinazione e ti guiderò.',
				response: {
					0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
					1: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
					2: { id: 'fossilFalls', label: planetNames.fossilFalls },
					3: (getDateNum() === '4') ? { id:'tostarenaTown', label: planetNames.tostarenaTown } : undefined,
					4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
					5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
				},
			},
		},
		dripDropGalaxy: (getDateNum() != '4') && {
			0: {
				question: 'Per la tua sicurezza, quest’area rimarrà chiusa fino a nuovo avviso.',
			},
		},
		tostarenaTown: (getDateNum() === '4')
			? {
				0: {
					question: 'Si consiglia protezione solare in ogni momento.',
					response: {
						0: 'Mostrami un’altra destinazione.'
					}
				},
				1: {
					question: 'Certamente. Scegli la tua destinazione e ti guiderò.',
					response: {
						0: { id: 'mushroomKingdom', label: planetNames.mushroomKingdom },
						1: { id: 'honeyhiveGalaxy', label: planetNames.honeyhiveGalaxy },
						2: { id: 'fossilFalls', label: planetNames.fossilFalls },
						3: { id: 'cometObservatory', label: planetNames.cometObservatory },
						4: (getDateNum() === '4') ? { id:'dripDropGalaxy', label: planetNames.dripDropGalaxy } : undefined,
						5: (getDateNum() === '4') ? { id:'spaceJunkGalaxy', label: planetNames.spaceJunkGalaxy } : undefined
					}
				}
			}
			: {
				0: {
					question: 'Per la tua sicurezza, quest’area rimarrà chiusa fino a nuovo avviso.',
				},
			},
		spaceJunkGalaxy: (getDateNum() != '4') && {
			0: {
				question: 'Per la tua sicurezza, quest’area rimarrà chiusa fino a nuovo avviso.',
			},
		},

		glyph: {
			0: {
				question: 'Se vedi qualcosa, segnalalo.',
			},
			1: {
				question: 'Accesso consentito.',
			},
			2: {
				question: 'Riprova.',
			},
			3: {
				question: "Let's not do that again."
			},
		},
		upWorld: {
			// State 0
			0: {
				question: 'Sembra… interessante.',
				response: {
					0: 'Torna alla home.',
				},
			},
			// State 1
			1: {
				question: "I livelli d'illuminazione sono aumentati.",
				response: {
					0: 'Torna alla home.',
				},
			},
			// State 3
			2: {
				question: 'Ulteriori dettagli strutturali sono ora visibili.',
				response: {
					0: 'Torna alla home.',
				},
			},
			//State 4
			3: {
				question: 'I parametri della destinazione si stanno definendo.',
				response: {
					0: 'Torna alla home.',
				},
			},
			//State 5 - April 1st
			4: {
				question: 'Destinazione confermata. Ora puoi prenotare i biglietti per Pianeta Bowser.',
				response: {
					0: 'Prenota Ora',
				},
			},
		},
		downWorld: {
			0: {
				question: 'Questa rotta non era prevista.',
			},
			1: {
				question: 'Procedi con cautela.',
				response: {
					0: 'Torniamo indietro.',
				},
			},
		},
		boomerang: {
			0: {
				question: 'Object incoming... please... duck'
			}
		},
		inputPlaceholder: 'Inserisci il codice.',
	},
	// ALT TEXT
	$altWeatherIcon: "L'icona meteo, indica le condizioni ambientali all’interno del Varco Celestiale.",
	$altLogoBoomerang:
		'Il logo della compagnia aerea Boomerang Bros. International Airlines, con un’icona audace di aeromobile a forma di boomerang, è ispirata all’arma simbolo dei Boomerang Bros.',
	$altLogoGalaxyAir:
		'Il logo della compagnia Galaxy Air, con un’icona luminosa di stella cadente, rappresenta i viaggi intergalattici e le rotte ad alta velocità.',
	$altLogoSunshineAir: "Il logo della compagnia Sunshine Airline con il Sole Custode, è un omaggio alla fonte di energia iconica dell'Isola Delfino.",
	$altConstructionIcon: "L'icona “in costruzione”, indica destinazioni o funzionalità non ancora disponibili nel Varco Celestiale.",
	$altRob: 'R.O.B., acronimo di Robotic Operating Buddy, serve da guida all’interno del sistema di viaggio del Varco Celestiale.',
	$legalsPrompt: 'Informazioni legali e sulla privacy',
	$legalsPromptMobile: 'Privacy',
	$legals : {
		adChoices: 'Scelte annunci',
		cookiePreferences: 'Impostazioni dei Cookie',
		privacyPolicy: 'Informativa sulla privacy',
		termsOfService: 'Condizioni di servizio',
		powster: 'Platform © 2026 powster',
		nbcUniversal: '© 2026 NBCUniversal media, LLC',
		links: {
			adChoices: 'https://www.nbcuniversalprivacy.com/privacy-policy/informativa-sui-cookie#accordionheader2',
			privacyPolicy: ' https://www.nbcuniversalprivacy.com/privacy-policies/privacy-italian',
			termsOfService: 'https://www.nbcuniversal.com/terms',
			powster: 'https://www.powster.com/',
		},
	},
};
